export default {
  owned: 'owned',

  gem_prestigeStone: {
    name: 'Prestige stone',
    description: 'Get prestige currency equal to your best cycle'
  },
  mining_goldenHammer: {
    name: 'Golden hammer',
    description: 'Get the best pickaxe possible for this craft'
  },
  village_ingredientBox: {
    name: 'Ingredient box',
    description: 'Contains special ingredients that can only be found in these boxes'
  },
  horde_manaPotion: {
    name: 'Mana potion',
    description: 'Refill 50% of your maximum mana'
  },
  farm_basic: {
    name: 'Basic fertilizer',
    description: ''
  },
  farm_flower: {
    name: 'Flower fertilizer',
    description: ''
  },
  farm_speedGrow: {
    name: 'Speed-grow',
    description: ''
  },
  farm_richSoil: {
    name: 'Rich soil',
    description: ''
  },
  farm_shiny: {
    name: 'Shiny fertilizer',
    description: ''
  },
  farm_juicy: {
    name: 'Juicy fertilizer',
    description: ''
  },
  farm_dissolving: {
    name: 'Crop dissolver',
    description: ''
  },
  farm_potatoWater: {
    name: 'Potato water',
    description: ''
  },
  farm_roseWater: {
    name: 'Rose water',
    description: ''
  },
  farm_weedKiller: {
    name: 'Weed killer',
    description: ''
  },
  farm_turboGrow: {
    name: 'Turbo-grow',
    description: ''
  },
  farm_premium: {
    name: 'Premium fertilizer',
    description: ''
  },
  farm_analyzing: {
    name: 'Analyzing fertilizer',
    description: ''
  },
  farm_superJuicy: {
    name: 'Super-juicy',
    description: ''
  },
  farm_pellets: {
    name: 'Pellets',
    description: ''
  },
  farm_supplementsS: {
    name: 'Supplements (S)',
    description: ''
  },
  farm_supplementsM: {
    name: 'Supplements (M)',
    description: ''
  },
  farm_supplementsL: {
    name: 'Supplements (L)',
    description: ''
  },
  farm_supplementsXL: {
    name: 'Supplements (XL)',
    description: ''
  },
  farm_supplementsXXL: {
    name: 'Supplements (XXL)',
    description: ''
  },
  gallery_surpriseParty: {
    name: 'Surprise party',
    description: 'Gain 500 motivation'
  },
  treasure_upArrow: {
    name: 'Up arrow',
    description: 'Increases treasure level by 2'
  },
  treasure_expander: {
    name: 'Expander',
    description: 'Treasure level increases over time, but cannot be upgraded using fragments'
  },
  treasure_wildcard: {
    name: 'Wildcard',
    description: 'All effects can be chosen again'
  },
  treasure_eventStar: {
    name: 'Event star',
    description: 'Adds event power as an effect'
  },
};
